export const apiURL = (() => {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_API_URL_DEV;
  }
  if (process.env.REACT_APP_STAGE === "homologation") {
    return process.env.REACT_APP_API_URL_DEV;
  }
  return process.env.REACT_APP_API_URL;
})();
